import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import VisitsToConfirmContainer from './VisitsToConfirmContainer';
import { getVisitsToConfirm } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import VisitsToConfirmEmptyState from './VisitsToConfirmEmptyState';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';
import { AGENT } from '@/components/FilterBar/constants/filtersConstants';

function VisitsToConfirm() {
  const dispatch = useDispatch();
  const track = useTrackPendingTab();
  const { count, loading, hasFetched, empty } = useSelector(
    (state) => state.DashboardSlice.visitsToConfirm
  );
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const selectedIds = useSelector(
    (state) => state.FilterBarSlice.filters.selectedIds
  );
  const selectedAgentIds = useMemo(
    () =>
      selectedIds
        .filter((filter) => filter.filter_type === AGENT)
        .map((filter) => filter.id),
    [selectedIds]
  );
  const { is_company_admin: isCompanyAdmin } = useSelector(
    (state) => state.AuthSlice.permissions
  );
  // /properties/visit only reads agent_ids when its own AgentsDropdown is
  // rendered (same gating condition), otherwise the filter would never apply.
  const canApplyAgentFilterOnVisits = isCompanyAdmin;
  const urlRedirect =
    canApplyAgentFilterOnVisits && selectedAgentIds.length
      ? `/properties/visit?agent_ids=${selectedAgentIds.join(',')}`
      : '/properties/visit';

  const visitsText = `${count} ${Trans(
    translations,
    count === 1 ? 'VisitToConfirm' : 'VisitsToConfirm'
  )}`;

  useFetchOnViewport(
    (query) => {
      dispatch(getVisitsToConfirm(query));
    },
    [],
    { hasFetched }
  );

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.visitsToConfirm(element)}
      >
        {visitsText}
      </PendingCard.Header>
      {empty ? (
        <VisitsToConfirmEmptyState />
      ) : (
        <VisitsToConfirmContainer
          trackCallback={(element) => track.visitsToConfirm(element)}
        />
      )}
    </PendingCard>
  );
}

export default VisitsToConfirm;
